import t from 'rcm-i18n';
import React, { Component } from 'react';

interface Props {
    allowedDiscountPercents: any;
    onDiscountPercentChange: Function;
    defaultDiscountPercent: number;
    alertWhenCanSelectHigherDiscount: boolean;
    discountPercent: number;
}

interface State {
    showWarningModal: boolean;
    newDiscountPercent: number;
}

export default class DiscountPercentSelect extends Component<Props, State> {
    constructor(props) {
        super(props);
        this.handleWarningModalContinue = this.handleWarningModalContinue.bind(this);
        this.handleWarningModalCancel = this.handleWarningModalCancel.bind(this);
        this.handleInternalDiscountPercentChange = this.handleInternalDiscountPercentChange.bind(this);
        this.state = {showWarningModal: false, newDiscountPercent: null};
    }
    public handleWarningModalContinue() {
        this.props.onDiscountPercentChange(this.state.newDiscountPercent);
        this.setState({showWarningModal: false});
    }

    public handleWarningModalCancel() {
        this.setState({showWarningModal: false});
    }

    public handleInternalDiscountPercentChange(event) {
        const newDiscountPercent = event.target.value;
        if (newDiscountPercent > this.props.defaultDiscountPercent) {
            this.setState({showWarningModal: true, newDiscountPercent});
        } else {
            this.props.onDiscountPercentChange(newDiscountPercent);
        }
    }

    public render() {
        if (this.props.allowedDiscountPercents.length === 0) {
            return null;
        }
        return (
            <tbody>
            {this.props.alertWhenCanSelectHigherDiscount && this.props.discountPercent < this.props.defaultDiscountPercent &&
            <tr className="discountPercentSelected">
                <td colSpan={2}>
                    <div className="alert alert-warning">{t('You can select a higher discount')}</div>
                </td>
            </tr>
            }
            <tr className="discountPercentSelected">
                <td>{t('Discount Level')}</td>
                <td className="money discountPercent">
                    <select onChange={this.handleInternalDiscountPercentChange} value={this.props.discountPercent}>
                        {this.props.allowedDiscountPercents.map((choice) =>
                            <option value={choice.value} key={choice.value}>{choice.label}</option>
                        )}
                    </select>
                    {this.state.showWarningModal &&
                    <div className="modal show">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-body" style={{textAlign: 'left'}}>
                                    <p>
                                        <span style={{whiteSpace: 'normal'}}>
                                            {t('Before selecting a higher discount level, please verify you meet the necessary requirements with your sponsor. Your current discount level is:') + ' ' + this.props.defaultDiscountPercent + '%'}
                                        </span>
                                    </p>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-default"
                                            onClick={this.handleWarningModalContinue}>
                                        {t('Continue with higher discount level')}
                                    </button>
                                    <button type="button" className="btn btn-primary"
                                            onClick={this.handleWarningModalCancel}>
                                        {t('Cancel')}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                </td>
            </tr>
            </tbody>
        );
    }
}
